import { IdResidence } from 'civil-status/constants/id-residence';
import { ParentVM } from 'civil-status/view-models/step-form';
import { DateTime } from 'luxon';
import { defaultChoicePickerState } from 'shell/components/shared/choice-date/constants';
import { ID_ITALIAN_NATION } from 'shell/constants/id-italian-nation';
import { AvvocatoConiuge } from 'shell/models/act-category-list';
import { isObjectEmpty } from 'shell/utils/is-object-empty';

export const transformerLawyer = (
  values?: AvvocatoConiuge,
  lawyerForum?: string
): ParentVM | undefined => {
  if (!values || isObjectEmpty((values || {}) as Record<string, unknown>)) {
    return;
  }

  const typeResidence = values.idStatoResidenza
    ? values.idStatoResidenza === ID_ITALIAN_NATION?.toString()
      ? IdResidence.Italian
      : IdResidence.Foreign
    : IdResidence.NotKnown;
  const isForeignBorn = values.idStatoNascita !== ID_ITALIAN_NATION?.toString();

  return {
    searchPerson: {
      birthdayDateChoice: values.dataNascita ? defaultChoicePickerState : undefined,
      birthdayDate: values.dataNascita ? DateTime.fromISO(values.dataNascita) : undefined,
      name: values.nome || '',
      surname: values.cognome || '',
      gender: values.sesso || '',
    },
    generality: {
      isRequiredFromOtherAccordion: true,
      name: values.nome || '',
      surname: values.cognome || '',
      birthDate: values.dataNascita ? DateTime.fromISO(values.dataNascita) : null,
      gender: values.sesso || '',
      civilStatusItem: {
        id: values.idstatocivile || '',
        value: values.descrizionestatocivile || '',
      },
      idAnsc: values.id || '',
      idAnpr: values.idANPR || '',
      fiscalCode: values.codiceFiscale || '',
      nationality: {
        id: values.idNazionalita || '',
        idAnpr: values.idNazionalita ? Number.parseInt(values.idNazionalita, 10) : undefined,
        value: values.nazionalita || '',
      },
      lawyerForum,
      isForeignBorn,
      italian: isForeignBorn
        ? undefined
        : {
            municipality: {
              code: values.idComuneNascita
                ? Number.parseInt(values.idComuneNascita, 10)
                : undefined,
              id: values.idComuneNascita || '',
              idProvince: values.idProvinciaNascita
                ? Number.parseInt(values.idProvinciaNascita, 10)
                : undefined,
              description: values.nomeComuneNascita || '',
              province: values.siglaProvinciaNascita || '',
            },
          },
      foreign: isForeignBorn
        ? {
            state: {
              code: values.idStatoNascita || '',
              id: values.idStatoNascita || '',
              value: values.nomeStatoNascita || '',
            },
            municipality: {
              id: values.idComuneNascita || '',
              idProvince: values.idProvinciaNascita
                ? Number.parseInt(values.idProvinciaNascita, 10)
                : undefined,
              description: values.nomeComuneNascita || '',
              province: values.siglaProvinciaNascita || '',
            },
          }
        : undefined,
      typeResidence,
      italianResidence:
        typeResidence === IdResidence.Italian
          ? {
              municipality: {
                code: values.idComuneResidenza
                  ? Number.parseInt(values.idComuneResidenza, 10)
                  : undefined,
                id: values.idComuneResidenza || '',
                idProvince: values.idProvinciaResidenza
                  ? Number.parseInt(values.idProvinciaResidenza, 10)
                  : undefined,
                description: values.nomeComuneResidenza || '',
                province: values.siglaProvinciaResidenza || '',
              },
            }
          : undefined,
      foreignResidence:
        typeResidence === IdResidence.Foreign
          ? {
              state: {
                code: values.idStatoResidenza || '',
                id: values.idStatoResidenza || '',
                value: values.nomeStatoResidenza || '',
              },
              municipality: {
                id: values.idComuneResidenza || '',
                idProvince: values.idProvinciaResidenza
                  ? Number.parseInt(values.idProvinciaResidenza, 10)
                  : undefined,
                description: values.nomeComuneResidenza || '',
                province: values.siglaProvinciaResidenza || '',
              },
            }
          : undefined,
      address: values.indirizzoResidenza || '',
    },
  };
};
